import React from 'react';
import dayjs from "dayjs";

import {CircularProgress, Option, Select, Stack} from "@mui/joy";
import Typography from "@mui/joy/Typography";
import Card from "@mui/joy/Card";

// components
import BaseApi from "../../utils/BaseApi";
import UserSubscriberContext from "../../context/UserSubscriberContext";
import FinancialModelLaborForecast from "./FinancialModelLaborForecast";
import {compareDates, customRange} from "../../utils/misc";
import UserLaborReport from "./UserLaborReport";
import LaborReportYearChart from "./LaborReportYearChart";
import OpportunitiesToGoCalendar from "../Opportunity/OpportunitiesToGoCalendar";


dayjs.locale('ru');


class LaborReport extends React.Component {
    static contextType = UserSubscriberContext

    constructor(props) {
        super(props);
        this.state = {
            forecastRevenues: null,
            xtypesChoices: null,
            overallReport: null,
            opportunityCalendars: null,
            numberOfMonth: null,
            norma: null,
            ready: false,
            year: new Date().getFullYear(),
        }
    }

    async componentDidMount() {
        await this.retrieveData();
    }

    async buildOverallReport(){
        const api = new BaseApi();
        let overallReport = {
            monthes: [],
            total: {
                capacity: 0,
                capacity_sixtyfive: 0,
                payRoll: 0,
                phase: 0,
                opportunity: 0,
                noOpportunity: 0,
                lostCapacity: 0,
                overload: 0,
                toGo: 0,
                forecast: 0,
                tail: 0,
            }
        };
        let url = this.props.employeeReportURL;
        let params = {
            year: this.state.year,
            category: 'ENGR',
        }
        let response = await api.get(
            url,
            params
        );
        let employeeReport = response.data
        url = this.props.calculatorURL;
        params = {
            year_end: this.state.year,
            year_start: this.state.year,
            model: 'TaskDailyDuration',
            period:	"month",
            field: '',
            date_field: '',
            groups: [],
            custom_date_field: 'date',
            custom_field: 'duration_fact',
        }
        params.queryset_params = JSON.stringify({
            "active": "True",
            "task__phase__isnull": "False"
        })
        response = await api.post(
            url,
            params
        );
        let phaseTasksReport = response.data
        params.custom_field = 'duration_plan'
        response = await api.post(
            url,
            params
        );
        let phaseTasksReportPlan = response.data
        params.custom_field = 'duration_fact'
        params.queryset_params = JSON.stringify({
            "active": "True",
            "task__phase__isnull": "True",
            "task__opportunity__isnull": "False",
        })
        response = await api.post(
            url,
            params
        );
        let opportunityTasksReport = response.data
        params.custom_field = 'duration_plan'
        response = await api.post(
            url,
            params
        );
        let opportunityTasksReportPlan = response.data
        params.custom_field = 'duration_fact'
        params.queryset_params = JSON.stringify({
            "active": "True",
            "task__phase__isnull": "True",
            "task__opportunity__isnull": "True",
        })
        response = await api.post(
            url,
            params
        );
        let noOpportunityTasksReport = response.data
        params.custom_field = 'duration_plan'
        response = await api.post(
            url,
            params
        );
        let noOpportunityTasksReportPlan = response.data
        url = `opportunity/calendars/`;
        response = await api.get(
            url,
            {
                forecast: true,
                tail: true
            },
        );
        let opportunityCalendars = response.data.calendars
        let numberOfMonth = response.data.max_calendar_monthes
        let norma = response.data.norma
        let currentMonth = (new Date).getMonth()
        for (let month of customRange(1,12,1)){
            let monthReport = {
                month: month,
                capacity: employeeReport.month[month].workhours,
                capacity_sixtyfive: employeeReport.month[month].workhours * 0.715,
                capacity_thirtyfive: employeeReport.month[month].workhours * 0.285,
                overload: 0,
                payRoll: employeeReport.month[month].salary_with_occupation,
                phase: phaseTasksReport.stats[this.state.year]?phaseTasksReport.stats[this.state.year][month].duration_fact:0,
                opportunity: opportunityTasksReport.stats[this.state.year]?opportunityTasksReport.stats[this.state.year][month].duration_fact:0,
                noOpportunity: noOpportunityTasksReport.stats[this.state.year]?noOpportunityTasksReport.stats[this.state.year][month].duration_fact:0,
                phasePlan: phaseTasksReportPlan.stats[this.state.year]?phaseTasksReportPlan.stats[this.state.year][month].duration_plan:0,
                opportunityPlan: opportunityTasksReportPlan.stats[this.state.year]?opportunityTasksReportPlan.stats[this.state.year][month].duration_plan:0,
                noOpportunityPlan: noOpportunityTasksReportPlan.stats[this.state.year]?noOpportunityTasksReportPlan.stats[this.state.year][month].duration_plan:0,
                lostCapacity: 0,
                toGo: 0,
                forecast: 0,
                tail: 0,
            }
            if (month <= currentMonth && this.state.year === (new Date).getFullYear() || this.state.year < (new Date).getFullYear()) {
                let lostCapacity = monthReport.capacity - monthReport.phase - monthReport.opportunity - monthReport.noOpportunity
                if (lostCapacity > 0){
                    monthReport.lostCapacity = lostCapacity
                }
                else {
                    monthReport.overload = -lostCapacity
                }
            }
            let index;
            if (this.state.year === (new Date).getFullYear()) {
                if (month > currentMonth){
                    index = month - currentMonth - 1
                }
            }
            else if (this.state.year > (new Date).getFullYear()){
                index = (this.state.year - (new Date).getFullYear() - 1) * 12 + 12 - currentMonth + month - 1
            }
            if (index !== undefined){
                if (index < Object.values(opportunityCalendars)[0].calendar[0].length){
                    monthReport.toGo += Object.values(opportunityCalendars).map(
                        (calendar) => {
                            return calendar.calendar.map(row => calendar.forecast?0:row[index]).reduce(
                                (accumulator, value) => accumulator + value * 8, 0
                            )
                        }
                    ).reduce(
                        (accumulator, value) => accumulator + value, 0
                    )
                    monthReport.forecast += Object.values(opportunityCalendars).map(
                        (calendar) => {
                            return calendar.calendar.map(row => calendar.forecast?row[index]:0).reduce(
                                (accumulator, value) => accumulator + value * 8, 0
                            )
                        }
                    ).reduce(
                        (accumulator, value) => accumulator + value, 0
                    )
                    monthReport.tail += Object.values(opportunityCalendars).map(
                        (calendar) => {
                            return calendar.calendar.map(row => calendar.tail?row[index]:0).reduce(
                                (accumulator, value) => accumulator + value * 8, 0
                            )
                        }
                    ).reduce(
                        (accumulator, value) => accumulator + value, 0
                    )
                }
            }

            overallReport.total.lostCapacity += monthReport.lostCapacity
            overallReport.total.overload += monthReport.overload
            overallReport.total.capacity += monthReport.capacity
            overallReport.total.capacity_sixtyfive += monthReport.capacity_sixtyfive
            overallReport.total.payRoll += monthReport.payRoll
            overallReport.total.phase += monthReport.phase
            overallReport.total.opportunity += monthReport.opportunity
            overallReport.total.noOpportunity += monthReport.noOpportunity
            overallReport.total.toGo += monthReport.toGo
            overallReport.total.forecast += monthReport.forecast
            overallReport.total.tail += monthReport.tail
            overallReport.monthes.push(monthReport)
        }
        return [
            overallReport,
            employeeReport,
            opportunityCalendars,
            numberOfMonth,
            norma
        ]
    }

    async retrieveData() {
        const api = new BaseApi();
        let forecastRevenues;
        let xtypesChoices;
        let url;
        let params;
        let response;
        let [
            overallReport,
            employeeReport,
            opportunityCalendars,
            numberOfMonth,
            norma
        ] = await this.buildOverallReport()
        if (this.props.showForecast){
            url = 'attachment/subscriber_xtypes/';
            response = await api.get(
                url,
                {},
            );
            xtypesChoices = [];
            for (const category of response.data.all_xtypes) {
                if (response.data.available_xtypes.includes(category[0])) {
                    xtypesChoices.push(category);
                }
            }
            url = 'opportunity/forecast';
            params = {
                year: this.state.year,
            }
            response = await api.get(
                url,
                params
            );
            forecastRevenues = response.data.by_start_date.revenue;
            forecastRevenues.sort(
                function(a, b) {
                    return compareDates(a, b)
                }
            )
        }
        this.setState({
            xtypesChoices: xtypesChoices,
            forecastRevenues: forecastRevenues,
            overallReport: overallReport,
            employeeReport: employeeReport,
            opportunityCalendars: opportunityCalendars,
            numberOfMonth: numberOfMonth,
            norma: norma,
            ready: true,
        });
    }

    render() {
        let currentYear = new Date().getFullYear();
        if (!this.state.ready) {
            return (
                <CircularProgress/>
            )
        }
        return (
            <Stack
                spacing={2}
                sx={{
                    width: '100%',
                }}
            >
                <Select
                    defaultValue={this.state.year}
                    onChange={(event, newValue) => {
                        this.setState({
                            year: parseInt(newValue)
                        }, this.retrieveData)
                    }}
                >
                    <Option value={currentYear - 2}>{currentYear - 2}</Option>
                    <Option value={currentYear - 1}>{currentYear - 1}</Option>
                    <Option value={currentYear}>{currentYear}</Option>
                    <Option value={currentYear + 1}>{currentYear + 1}</Option>
                    <Option value={currentYear + 2}>{currentYear + 2}</Option>
                    <Option value={currentYear + 3}>{currentYear + 3}</Option>
                </Select>
                <LaborReportYearChart
                    overallReport={this.state.overallReport}
                />
                {
                    this.props.showCalendar?
                        <Card>
                            <Typography
                                level={'h4'}
                            >
                                Календарь проектов
                            </Typography>
                            <OpportunitiesToGoCalendar
                                report={this.state.opportunityCalendars}
                                numberOfMonth={this.state.numberOfMonth}
                                norma={this.state.norma}
                            />
                        </Card>:
                        null
                }
                {
                    this.props.showForecast?
                        <Card>
                            <Typography
                                level={'h4'}
                            >
                                Календарь исполнителей
                            </Typography>
                            <FinancialModelLaborForecast
                                xtypeChoices={this.state.xtypesChoices}
                                forecastRevenues={this.state.forecastRevenues}
                            />
                        </Card>:
                        null
                }

                <Card>
                    <UserLaborReport
                        year={this.state.year}
                        calculatorURL={this.props.calculatorURL}
                        employeeReport={this.state.employeeReport}
                    />
                </Card>
            </Stack>
        )
    }
}

export default LaborReport;